import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  buildGetAdminProspectCampaignMailingPublicResponseRequest,
  parseGetAdminProspectCampaignMailingPublicResponse,
} from './prospectCampaignMailingPublicResponseRequest.js';

export {
  buildGetAdminProspectCampaignMailingPublicResponseRequest,
  parseGetAdminProspectCampaignMailingPublicResponse,
} from './prospectCampaignMailingPublicResponseRequest.js';

export async function getAdminProspectCampaignMailingPublicResponse(input) {
  const request = buildGetAdminProspectCampaignMailingPublicResponseRequest(input);
  const callable = httpsCallable(functions, 'getAdminProspectCampaignMailingPublicResponse');
  const result = await callable(request);
  return parseGetAdminProspectCampaignMailingPublicResponse(result?.data);
}
